module.exports = __webpack_public_path__ + "assets/img/29_231.b5b15325.jpg";